import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Employee } from './Employee'
import {ANNIE_KRAMER, REBECCA_HOLDREDGE, SARAH_ANTONELLO, JAKE_BROWN} from './../../Data/Employees';
import Fade from 'react-reveal/Fade'

export class MeetMain extends Component {
    render() {
        return (
            <div id="meet" className="jumbotron shadow sec-width mx-auto bg-color-grey">
                <div className="mx-3 antic">
                    <Fade>
                        <h1 className="w-100 heading-font bg-color-heading rounded pl-5">Meet the Team</h1>
                    </Fade>  
                        <Fade>
                        <div className="row px-3">
                            <Employee employee={SARAH_ANTONELLO}/>
                        </div>
                        </Fade>
                        <Fade>
                        <div className="row px-3">
                            <Employee employee={JAKE_BROWN}/>
                        </div>
                        </Fade>
                        <Fade>
                        <div className="row px-3">
                            <Employee employee={REBECCA_HOLDREDGE}/>
                        </div>
                        </Fade>
                        <Fade>
                        <div className="row px-3">
                            <Employee employee={ANNIE_KRAMER}/>
                        </div>
                        </Fade>
                          
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    state
})



export default connect(mapStateToProps, {})(MeetMain)
